// ===================================================================
// THIS FILE WAS AUTO GENERATED DO NOT EDIT IMPLACE
// ===================================================================
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

export enum ECpmCJobsRoleApiEnum {
    SCHEDULER = 'SCHEDULER',
    GOVERNOR = 'GOVERNOR',
    EXECUTOR = 'EXECUTOR'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCJobsRoleApiEnum = Object.fromEntries(
    Object.entries(ECpmCJobsRoleApiEnum)
        .map(([key, value]) => [
            value,
            key as ECpmCJobsRoleApiEnum
        ])
);


// ===============================================================
// ===============================================================

export enum ECpmCJobsUnregisterInstanceReasonApiEnum {
    TIMEOUT = 'TIMEOUT',
    CONFLICT = 'CONFLICT',
    REMOTE_UNREGISTERED = 'REMOTE_UNREGISTERED'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCJobsUnregisterInstanceReasonApiEnum = Object.fromEntries(
    Object.entries(ECpmCJobsUnregisterInstanceReasonApiEnum)
        .map(([key, value]) => [
            value,
            key as ECpmCJobsUnregisterInstanceReasonApiEnum
        ])
);


// ===============================================================
// ===============================================================

export enum ECpmCJobsGovenorStartJobResultApiEnum {
    STARTED = 'STARTED',
    FAILED = 'FAILED',
    NO_EXECUTOR_AVAILABLE = 'NO_EXECUTOR_AVAILABLE'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCJobsGovenorStartJobResultApiEnum = Object.fromEntries(
    Object.entries(ECpmCJobsGovenorStartJobResultApiEnum)
        .map(([key, value]) => [
            value,
            key as ECpmCJobsGovenorStartJobResultApiEnum
        ])
);


// ===============================================================
// ===============================================================

export enum ECpmCJobsExecutorStartJobResultApiEnum {
    STARTED = 'STARTED',
    FAILED = 'FAILED',
    NO_FREE_SLOT = 'NO_FREE_SLOT'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCJobsExecutorStartJobResultApiEnum = Object.fromEntries(
    Object.entries(ECpmCJobsExecutorStartJobResultApiEnum)
        .map(([key, value]) => [
            value,
            key as ECpmCJobsExecutorStartJobResultApiEnum
        ])
);


// ===============================================================
// ===============================================================

export enum ECpmCJobsJobFailedReasonApiEnum {
    ON_RESTART = 'ON_RESTART',
    LOST_EXECUTOR = 'LOST_EXECUTOR',
    LOST_GOVENOR = 'LOST_GOVENOR',
    LOST_SCHEDULER = 'LOST_SCHEDULER',
    EXECUTION_TIMEOUT = 'EXECUTION_TIMEOUT',
    IMPLEMENTATION_ERROR = 'IMPLEMENTATION_ERROR',
    NOT_SATISFIABLE = 'NOT_SATISFIABLE'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCJobsJobFailedReasonApiEnum = Object.fromEntries(
    Object.entries(ECpmCJobsJobFailedReasonApiEnum)
        .map(([key, value]) => [
            value,
            key as ECpmCJobsJobFailedReasonApiEnum
        ])
);

